{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-520000",
  "sheetId": "StatementOfCashFlowsIndirectMethod",
  "label": "[520000] Statement of cash flows, indirect method (MPERS)",
  "description": "Statement of cash flows using indirect method reconciling profit to cash flows from operating activities (MPERS)",
  "taxonomy": "FS-MPERS",
  "controls": [
    {
      "qname": "ssmt:StatementOfCashFlowsHeader",
      "label": "Statement of cash flows",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 1
      }
    },
    {
      "qname": "ssmt:CashFlowsFromOperatingActivitiesIndirectHeader",
      "label": "Cash flows from (used in) operating activities",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ifrs-smes:ProfitLossBeforeTax",
      "label": "Profit (loss) before tax, from continuing operations",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfProfitOrLoss",
            "field": "ifrs-smes:ProfitLossBeforeTax"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:ProfitLossFromDiscontinuedOperations",
      "label": "Profit (loss) before tax, from discontinued operation",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfProfitOrLoss",
            "field": "ifrs-smes:ProfitLossFromDiscontinuedOperations"
          }
        ]
      }
    },
    {
      "qname": "ssmt-mpers:AggregateProfitLossBeforeTax",
      "required": true,
      "label": "Total profit (loss) before tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= ProfitLossFromContinuingOperations + ProfitLossFromDiscontinuedOperations",
        "dependencies": [
          "ifrs-smes:ProfitLossBeforeTax",
          "ifrs-smes:ProfitLossFromDiscontinuedOperations"
        ]
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsToReconcileProfitLossHeader",
      "label": "Adjustments to reconcile profit (loss)",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForNoncashIncomeTaxExpense",
      "label": "Adjustments for non-cash income tax expense",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForNoncashFinanceCosts",
      "label": "Adjustments for non-cash finance costs",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForIncomeTaxExpense",
      "label": "Adjustments for income tax expense",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForFinanceCosts",
      "label": "Adjustments for finance costs",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:AdjustmentsForFinanceIncome",
      "label": "(-) Adjustments for finance income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForDecreaseIncreaseInInventories",
      "label": "Adjustments for decrease (increase) in inventories",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForDecreaseIncreaseInTradeAccountReceivable",
      "label": "Adjustments for decrease (increase) in trade accounts receivable",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForDecreaseIncreaseInOtherOperatingReceivables",
      "label": "Adjustments for decrease (increase) in other operating receivables",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForIncreaseDecreaseInTradeAccountPayable",
      "label": "Adjustments for increase (decrease) in trade accounts payable",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForIncreaseDecreaseInOtherOperatingPayables",
      "label": "Adjustments for increase (decrease) in other operating payables",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:AdjustmentsForDividendIncome",
      "label": "(-) Adjustments for dividend income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:AdjustmentsForDepreciationExpense",
      "label": "Adjustment for depreciation",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:AdjustmentsForAmortisationExpense",
      "label": "Adjustments for amortisation",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:ImpairmentLossRecognisedInProfitOrLossIntangibleAssetsOtherThanGoodwill",
      "label": "(Reversal of)/Impairment loss on intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:ImpairmentLossRecognisedInProfitOrLossPropertyPlantAndEquipment",
      "label": "(Reversal of)/Impairment loss on property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:ReversalOfInventoryWritedown",
      "label": "(Reversal of)/Impairment loss on inventories",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "analysisOfProfitOrLoss",
            "field": "ifrs-smes:ReversalOfInventoryWritedown"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForProvisions",
      "label": "Adjustments for provisions",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForUnrealisedForeignExchangeLossesGains",
      "label": "Adjustments for unrealised foreign exchange losses (gains)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForSharebasedPayments",
      "label": "Adjustments for share-based payments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForFairValueGainsLosses",
      "label": "Adjustments for fair value losses (gains)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:AdjustmentsForShareOfProfitOfEquityAccountedAssociatesAndJointVenturesNetOfTax",
      "label": "(-) Adjustments for share of profit of equity-accounted associates and joint ventures, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForAccruedIncomeExpensesNotYetReceivedPaid",
      "label": "(-) Adjustments for accrued expenses (income) not yet paid (received)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherAdjustmentsForNoncashItems",
      "label": "Other adjustments for non-cash items",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:GainsLossesOnDisposalsOfPropertyPlantAndEquipment",
      "label": "(-) (Gain) loss on disposal of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:GainsLossesOnDisposalsOfInvestmentProperties",
      "label": "(-) (Gain) loss on disposal of investment properties",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:GainsLossesOnDisposalOfOtherInvestments",
      "label": "(-) (Gain) loss on disposal of other investments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherAdjustmentsForWhichCashEffectsAreInvestingOrFinancingCashFlow",
      "label": "Other adjustments for which cash effects are investing or financing cash flow",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherAdjustmentsToReconcileProfitLoss",
      "label": "Other adjustments to reconcile profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:AdjustmentsForReconcileProfitLoss",
      "required": true,
      "label": "Total adjustments to reconcile profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= Sum of all adjustment fields (1-28)",
        "dependencies": [
          "ifrs-smes:AdjustmentsForNoncashIncomeTaxExpense",
          "ifrs-smes:AdjustmentsForNoncashFinanceCosts",
          "ifrs-smes:AdjustmentsForIncomeTaxExpense",
          "ifrs-smes:AdjustmentsForFinanceCosts",
          "ssmt-mpers:AdjustmentsForFinanceIncome",
          "ifrs-smes:AdjustmentsForDecreaseIncreaseInInventories",
          "ifrs-smes:AdjustmentsForDecreaseIncreaseInTradeAccountReceivable",
          "ifrs-smes:AdjustmentsForDecreaseIncreaseInOtherOperatingReceivables",
          "ifrs-smes:AdjustmentsForIncreaseDecreaseInTradeAccountPayable",
          "ifrs-smes:AdjustmentsForIncreaseDecreaseInOtherOperatingPayables",
          "ssmt-mpers:AdjustmentsForDividendIncome",
          "ssmt-mpers:AdjustmentsForDepreciationExpense",
          "ssmt-mpers:AdjustmentsForAmortisationExpense",
          "ifrs-smes:ImpairmentLossRecognisedInProfitOrLossIntangibleAssetsOtherThanGoodwill",
          "ifrs-smes:ImpairmentLossRecognisedInProfitOrLossPropertyPlantAndEquipment",
          "ifrs-smes:ReversalOfInventoryWritedown",
          "ifrs-smes:AdjustmentsForProvisions",
          "ifrs-smes:AdjustmentsForUnrealisedForeignExchangeLossesGains",
          "ifrs-smes:AdjustmentsForSharebasedPayments",
          "ifrs-smes:AdjustmentsForFairValueGainsLosses",
          "ssmt-mpers:AdjustmentsForShareOfProfitOfEquityAccountedAssociatesAndJointVenturesNetOfTax",
          "ifrs-smes:AdjustmentsForAccruedIncomeExpensesNotYetReceivedPaid",
          "ifrs-smes:OtherAdjustmentsForNoncashItems",
          "ssmt-mpers:GainsLossesOnDisposalsOfPropertyPlantAndEquipment",
          "ssmt-mpers:GainsLossesOnDisposalsOfInvestmentProperties",
          "ssmt-mpers:GainsLossesOnDisposalOfOtherInvestments",
          "ifrs-smes:OtherAdjustmentsForWhichCashEffectsAreInvestingOrFinancingCashFlow",
          "ifrs-smes:OtherAdjustmentsToReconcileProfitLoss"
        ]
      }
    },
    {
      "qname": "ssmt-mpers:CashFlowsFromUsedInOperations",
      "label": "Cash generated from (used in) operating activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= AggregateProfitLossBeforeTax + AdjustmentsForReconcileProfitLoss",
        "dependencies": [
          "ssmt-mpers:AggregateProfitLossBeforeTax",
          "ifrs-smes:AdjustmentsForReconcileProfitLoss"
        ]
      }
    },
    {
      "qname": "ifrs-smes:DividendsPaidClassifiedAsOperatingActivities",
      "label": "Dividends paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:DividendsReceivedClassifiedAsOperatingActivities",
      "label": "Dividends received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:InterestPaidClassifiedAsOperatingActivities",
      "label": "Interest paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:InterestReceivedClassifiedAsOperatingActivities",
      "label": "Interest received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:IncomeTaxesPaidRefundClassifiedAsOperatingActivities",
      "label": "Income taxes refund (paid)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherInflowsOutflowsOfCashClassifiedAsOperatingActivities",
      "label": "Other cash inflows (outflows) from operating activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:CashFlowsFromUsedInOperatingActivities",
      "required": true,
      "label": "Net cash flows from (used in) operating activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= CashFlowsFromOperations + DividendsPaid + DividendsReceived + InterestPaid + InterestReceived + IncomeTaxes + OtherCashFlows",
        "dependencies": [
          "ssmt-mpers:CashFlowsFromUsedInOperations",
          "ifrs-smes:DividendsPaidClassifiedAsOperatingActivities",
          "ifrs-smes:DividendsReceivedClassifiedAsOperatingActivities",
          "ifrs-smes:InterestPaidClassifiedAsOperatingActivities",
          "ifrs-smes:InterestReceivedClassifiedAsOperatingActivities",
          "ifrs-smes:IncomeTaxesPaidRefundClassifiedAsOperatingActivities",
          "ifrs-smes:OtherInflowsOutflowsOfCashClassifiedAsOperatingActivities"
        ]
      }
    },
    {
      "qname": "ifrs-smes:CashFlowsFromUsedInInvestingActivitiesHeader",
      "label": "Cash flows from (used in) investing activities",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ifrs-smes:CashFlowsFromLosingControlOfSubsidiariesOrOtherBusinessesClassifiedAsInvestingActivities",
      "label": "Proceeds from disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:CashFlowsUsedInObtainingControlOfSubsidiariesOrOtherBusinessesClassifiedAsInvestingActivities",
      "label": "(-) Acquisition and subscription of shares in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherCashReceiptsFromSalesOfInterestsInJointVenturesClassifiedAsInvestingActivities",
      "label": "Proceeds from disposal of joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherCashPaymentsToAcquireInterestsInJointVenturesClassifiedAsInvestingActivities",
      "label": "(-) Acquisition and subscription of shares in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherCashReceiptsFromSalesOfEquityOrDebtInstrumentsOfOtherEntitiesClassifiedAsInvestingActivities",
      "label": "Other cash receipts from sales of equity or debt instruments of other entities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherCashPaymentsToAcquireEquityOrDebtInstrumentsOfOtherEntitiesClassifiedAsInvestingActivities",
      "label": "(-) Other cash payments to acquire equity or debt instruments of other entities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:ProceedsFromSalesOfPropertyPlantAndEquipmentClassifiedAsInvestingActivities",
      "label": "Proceeds from sales of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:PurchaseOfPropertyPlantAndEquipmentClassifiedAsInvestingActivities",
      "label": "(-) Purchase of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:ProceedsFromSalesOfIntangibleAssetsClassifiedAsInvestingActivities",
      "label": "Proceeds from sales of intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:PurchaseOfIntangibleAssetsClassifiedAsInvestingActivities",
      "label": "(-) Purchase of intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:ProceedsFromOtherLongtermAssetsClassifiedAsInvestingActivities",
      "label": "Proceeds from sales of other long-term assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:PurchaseOfOtherLongtermAssetsClassifiedAsInvestingActivities",
      "label": "(-) Purchase of other long-term assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:CashAdvancesAndLoansMadeToOtherPartiesClassifiedAsInvestingActivities",
      "label": "(-) Cash advances and loans made to other parties",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:CashReceiptsFromRepaymentOfAdvancesAndLoansMadeToOtherPartiesClassifiedAsInvestingActivities",
      "label": "Cash receipts from repayment of advances and loans made to other parties",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:CashPaymentsForFutureContractsForwardContractsOptionContractsAndSwapContractsClassifiedAsInvestingActivities",
      "label": "(-) Cash payments for futures contracts, forward contracts, option contracts and swap contracts",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:CashReceiptsFromFutureContractsForwardContractsOptionContractsAndSwapContractsClassifiedAsInvestingActivities",
      "label": "Cash receipts from futures contracts, forward contracts, option contracts and swap contracts",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:DividendsReceivedClassifiedAsInvestingActivities",
      "label": "Dividends received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:InterestReceivedClassifiedAsInvestingActivities",
      "label": "Interest received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherInflowsOutflowsOfCashClassifiedAsInvestingActivities",
      "label": "Other inflows (outflows) of cash from investing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:CashFlowsFromUsedInInvestingActivities",
      "required": true,
      "label": "Net cash flows from (used in) investing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= Sum of all investing activity fields (1-19)",
        "dependencies": [
          "ifrs-smes:CashFlowsFromLosingControlOfSubsidiariesOrOtherBusinessesClassifiedAsInvestingActivities",
          "ifrs-smes:CashFlowsUsedInObtainingControlOfSubsidiariesOrOtherBusinessesClassifiedAsInvestingActivities",
          "ifrs-smes:OtherCashReceiptsFromSalesOfInterestsInJointVenturesClassifiedAsInvestingActivities",
          "ifrs-smes:OtherCashPaymentsToAcquireInterestsInJointVenturesClassifiedAsInvestingActivities",
          "ifrs-smes:OtherCashReceiptsFromSalesOfEquityOrDebtInstrumentsOfOtherEntitiesClassifiedAsInvestingActivities",
          "ifrs-smes:OtherCashPaymentsToAcquireEquityOrDebtInstrumentsOfOtherEntitiesClassifiedAsInvestingActivities",
          "ifrs-smes:ProceedsFromSalesOfPropertyPlantAndEquipmentClassifiedAsInvestingActivities",
          "ifrs-smes:PurchaseOfPropertyPlantAndEquipmentClassifiedAsInvestingActivities",
          "ifrs-smes:ProceedsFromSalesOfIntangibleAssetsClassifiedAsInvestingActivities",
          "ifrs-smes:PurchaseOfIntangibleAssetsClassifiedAsInvestingActivities",
          "ifrs-smes:ProceedsFromOtherLongtermAssetsClassifiedAsInvestingActivities",
          "ifrs-smes:PurchaseOfOtherLongtermAssetsClassifiedAsInvestingActivities",
          "ifrs-smes:CashAdvancesAndLoansMadeToOtherPartiesClassifiedAsInvestingActivities",
          "ifrs-smes:CashReceiptsFromRepaymentOfAdvancesAndLoansMadeToOtherPartiesClassifiedAsInvestingActivities",
          "ifrs-smes:CashPaymentsForFutureContractsForwardContractsOptionContractsAndSwapContractsClassifiedAsInvestingActivities",
          "ifrs-smes:CashReceiptsFromFutureContractsForwardContractsOptionContractsAndSwapContractsClassifiedAsInvestingActivities",
          "ifrs-smes:DividendsReceivedClassifiedAsInvestingActivities",
          "ifrs-smes:InterestReceivedClassifiedAsInvestingActivities",
          "ifrs-smes:OtherInflowsOutflowsOfCashClassifiedAsInvestingActivities"
        ]
      }
    },
    {
      "qname": "ifrs-smes:CashFlowsFromUsedInFinancingActivitiesHeader",
      "label": "Cash flows from (used in) financing activities",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ifrs-smes:ProceedsFromIssuingShares",
      "label": "Proceeds from issuing shares",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:ProceedsFromIssuingOtherEquityInstruments",
      "label": "Proceeds from issuing other equity instruments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:PaymentsToAcquireOrRedeemEntitysShares",
      "label": "(-) Payments to acquire or redeem entity's shares",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:PaymentsOfOtherEquityInstruments",
      "label": "(-) Payments of other equity instruments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:ProceedsFromBorrowingsClassifiedAsFinancingActivities",
      "label": "Proceeds from borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:RepaymentsOfBorrowingsClassifiedAsFinancingActivities",
      "label": "(-) Repayments of borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mpers:RepaymentOfLoanFromAssociate",
      "label": "(-) Repayment of loan from associate",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:PaymentsOfFinanceLeaseLiabilitiesClassifiedAsFinancingActivities",
      "label": "(-) Payments of finance lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:DividendsPaidClassifiedAsFinancingActivities",
      "label": "(-) Dividends paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:InterestPaidClassifiedAsFinancingActivities",
      "label": "(-) Interest paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:OtherInflowsOutflowsOfCashClassifiedAsFinancingActivities",
      "label": "Other cash inflows (outflows) from financing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:CashFlowsFromUsedInFinancingActivities",
      "required": true,
      "label": "Net cash flows from (used in) financing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= Sum of all financing activity fields (1-11)",
        "dependencies": [
          "ifrs-smes:ProceedsFromIssuingShares",
          "ifrs-smes:ProceedsFromIssuingOtherEquityInstruments",
          "ifrs-smes:PaymentsToAcquireOrRedeemEntitysShares",
          "ifrs-smes:PaymentsOfOtherEquityInstruments",
          "ifrs-smes:ProceedsFromBorrowingsClassifiedAsFinancingActivities",
          "ifrs-smes:RepaymentsOfBorrowingsClassifiedAsFinancingActivities",
          "ssmt-mpers:RepaymentOfLoanFromAssociate",
          "ifrs-smes:PaymentsOfFinanceLeaseLiabilitiesClassifiedAsFinancingActivities",
          "ifrs-smes:DividendsPaidClassifiedAsFinancingActivities",
          "ifrs-smes:InterestPaidClassifiedAsFinancingActivities",
          "ifrs-smes:OtherInflowsOutflowsOfCashClassifiedAsFinancingActivities"
        ]
      }
    },
    {
      "qname": "ifrs-smes:IncreaseDecreaseInCashAndCashEquivalentsBeforeEffectOfExchangeRateChanges",
      "required": true,
      "label": "Net increase (decrease) in cash and cash equivalents before effect of exchange rate changes",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= CashFlowsFromOperatingActivities + CashFlowsFromInvestingActivities + CashFlowsFromFinancingActivities",
        "dependencies": [
          "ifrs-smes:CashFlowsFromUsedInOperatingActivities",
          "ifrs-smes:CashFlowsFromUsedInInvestingActivities",
          "ifrs-smes:CashFlowsFromUsedInFinancingActivities"
        ]
      }
    },
    {
      "qname": "ifrs-smes:EffectOfExchangeRateChangesOnCashAndCashEquivalents",
      "label": "Effect of exchange rate changes on cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:IncreaseDecreaseInCashAndCashEquivalents",
      "required": true,
      "label": "Net increase (decrease) in cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= IncreaseDecreaseBeforeExchangeRateChanges + EffectOfExchangeRateChanges",
        "dependencies": [
          "ifrs-smes:IncreaseDecreaseInCashAndCashEquivalentsBeforeEffectOfExchangeRateChanges",
          "ifrs-smes:EffectOfExchangeRateChangesOnCashAndCashEquivalents"
        ]
      }
    },
    {
      "qname": "ifrs-smes:CashAndCashEquivalents:Beginning",
      "label": "Cash and cash equivalents at beginning of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "consecutiveYearCash": {
          "comparisons": [
            {
              "beginningConsolidationType": "Consolidated",
              "compareField": "ifrs-smes:CashAndCashEquivalents:End"
            },
            {
              "beginningConsolidationType": "Consolidated",
              "compareField": "ifrs-smes:CashAndCashEquivalents:End_occurrence2"
            },
            {
              "beginningConsolidationType": "Separate",
              "compareField": "ifrs-smes:CashAndCashEquivalents:End"
            },
            {
              "beginningConsolidationType": "Separate",
              "compareField": "ifrs-smes:CashAndCashEquivalents:End_occurrence2"
            }
          ],
          "sheet": "statementOfCashFlowsIndirectMethod"
        }
      }
    },
    {
      "qname": "ifrs-smes:CashAndCashEquivalents:End",
      "label": "Cash and cash equivalents at end of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ifrs-smes:CashAndCashEquivalents:End_occurrence2",
            "skipIfSourceNull": true,
            "message": "Mismatch in value provided for the same field. The value should match Cash and cash equivalents at end of period (under section Details of cash flows) in Statement of Cash Flows (Indirect Method)."
          }
        ]
      }
    },
    {
      "qname": "ssmt:DetailsOfCashFlowsHeader",
      "label": "Details of cash flows",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ssmt:CashAndBankBalances",
      "label": "Cash and bank balances",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfFinancialPosition",
            "field": "ssmt:CashAndBankBalances"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:BankOverdraftsClassifiedAsCashEquivalents",
      "label": "(-) Bank overdrafts",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt:OtherAdjustmentsToReconcileCashAndCashEquivalents",
      "label": "Other adjustments to reconcile cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-smes:CashAndCashEquivalents:End_occurrence2",
      "required": true,
      "label": "Cash and cash equivalents at end of period",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ifrs-smes:CashAndCashEquivalents:End",
            "skipIfTargetNull": true,
            "message": "Mismatch in value provided for the same field. The value should match Cash and cash equivalents at end of period (under section Cash flows from (used in) financing activities) in Statement of Cash Flows (Indirect Method)."
          }
        ]
      },
      "calculation": {
        "formula": "= CashAndBankBalances - BankOverdraft + OtherAdjustments",
        "dependencies": [
          "ssmt:CashAndBankBalances",
          "ifrs-smes:BankOverdraftsClassifiedAsCashEquivalents",
          "ssmt:OtherAdjustmentsToReconcileCashAndCashEquivalents"
        ]
      }
    }
  ]
}
